<template>
  <div class="viewer">
    <div v-if="activeStory" class="viewer_container">
      <v-card>
        <v-card-title><v-text-field outlined v-model="activeStory.name" label="Title"></v-text-field></v-card-title>
        <v-card-text>
          <v-form>
            <v-textarea outlined label="Description"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary">Save</v-btn>
        </v-card-actions>
      </v-card>
      <v-timeline>
        <v-slide-y-transition group>
          <template>
            <component :is="event.type" :data="event" v-for="event in activeStory.events" :key="event.id + '_' + event.type"/>
          </template>
        </v-slide-y-transition>
      </v-timeline>      
    </div>
    <div v-else>
      No story loaded.
    </div>
  </div>
</template>

<script>
import Say from './commands/Say.vue'
import Roll from './commands/Roll.vue'
import Ask from './commands/Ask.vue'
import Gimme from './commands/Gimme.vue'
import Decision from './commands/Decision.vue'
import { mapState } from 'vuex'

export default {
  name: 'StoryViewer',
  props: {
    msg: String
  },
  computed: {
    ...mapState(['activeStory', 'currentUser']),
  },
  components: {
    Say,
    Roll,
    Ask,
    Gimme,
    Decision
  }
}
</script>

<style scoped>

</style>
